import { useCallback } from "react";

import type { ConditionBuildable, DesignerCondition } from "../../types";
import { useResponseDesigner } from "../ResponseByIdContext";

type ConditionDesignerProps = {
  condition: DesignerCondition<any>;
  view?: "summary" | "edit";
};

// equivalent of NodeDesigner component
export const ConditionDesigner = ({
  condition: { builder, id, spec, config, children, buildables },
  view = "edit",
}: ConditionDesignerProps) => {
  const { updateCondition, removeCondition, createCondition, addCondition } = useResponseDesigner();
  const Component = builder.views[view];

  const handleConfigChange = useCallback(
    (newConfig: unknown) => {
      updateCondition(id, newConfig);
    },
    [id, updateCondition],
  );

  const handleRemoveChild = useCallback(
    (removeId: number) => {
      // TODO: verify it is indeed a child
      removeCondition(removeId);
    },
    [removeCondition],
  );

  const handleAddChild = useCallback(
    (name: string, conditionBuildable: ConditionBuildable<any>) => {
      const condition = createCondition(conditionBuildable);
      if (!condition) {
        console.warn(`Condition create failed for ${name}:${JSON.stringify(conditionBuildable)}`);
        return;
      }
      addCondition(condition, {
        parentId: id,
        name,
      });
    },
    [addCondition, createCondition, id],
  );

  return (
    <Component
      key={id}
      id={id}
      spec={spec}
      config={config}
      buildables={buildables}
      onConfigChange={handleConfigChange}
      onAddChild={handleAddChild}
      onRemoveChild={handleRemoveChild}
    >
      {children}
    </Component>
  );
};
